import { Flex, Menu } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackArrow from "../../assets/images/back-arrow.svg";
import { useToken } from "../../common/helper";
import { useSelector } from "react-redux";

function SettingsSidebar({ isUpdateForm, backUrl }) {
  const { decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  // menu from redux/store
  const main_menu = useSelector((state) => state.menu.items);
  const sub_menu = main_menu?.find((item)=>item?.name =='Settings')
  // console.log("sub-menu from server/store", sub_menu);

  const items = [];

const subMenus = sub_menu?.sub_menus || [];

const mySettingsChildren = [];
const companySettingsChildren = [];

// Loop through submenus
subMenus?.forEach((item) => {
  const routeKey = item?.route  // like 'profile', 'couriers', etc.
  const label = item?.label;
  const name = item?.name?.toLowerCase(); // case-insensitivity

  if (name === "general" || name === "notifications") {
    mySettingsChildren.push({
      key: routeKey,
      label: label,
    });
  } else {
    companySettingsChildren.push({
      key: routeKey,
      label: label,
    });
  }
});

// Now build the final items array
if (mySettingsChildren.length > 0) {
  items.push({
    key: "mySettings",
    type: "group",
    label: "My Settings",
    children: mySettingsChildren,
  });
}

if (companySettingsChildren.length > 0) {
  items.push({
    key: "companySettings",
    type: "group",
    label: "Company Settings",
    children: companySettingsChildren,
  });
}


  const userRole = decodedToken?.role?.toLowerCase();
  const isAdmin = true;
  const isEditor = false;

  // const items = [
  //   {
  //     key: "mySettings",
  //     type: "group",
  //     label: "My Settings",
  //     children: [
  //       {
  //         key: "profile",
  //         label: "General",
  //       },
  //       {
  //         key: "notification",
  //         label: "Notifications",
  //       },
  //       // ...(decodedToken?.company_name?.toLowerCase() == "zoomlogi"
  //       //   ? [{ key: "temp-notification", label: "Temp Notifications" }]
  //       //   : []),
  //     ],
  //   },
  //   ...(isAdmin
  //     ? [
  //         {
  //           key: "companySettings",
  //           type: "group",
  //           label: "Company Settings",
  //           children: [
  //             {
  //               key: "couriers",
  //               label: "Transport Providers",
  //             },
  //             {
  //               key:  "product",
  //               label: "Products",
  //             },
  //             {
  //               key: "sensor",
  //               label: "Sensors",
  //             },
  //             {
  //               key:  "team",
  //               label: "Teams",
  //             },
  //             {
  //               key:  "location",
  //               label: "Locations",
  //             },
  //             {
  //               key:  "user",
  //               label: "Users",
  //             },
  //             {
  //               key:  "roles",
  //               label: "Roles & permissions",
  //             },
  //           ],
  //         },
  //       ]
  //     : isEditor
  //     ? [
  //         {
  //           key: "companySettings",
  //           type: "group",
  //           label: "Company Settings",
  //           children: [
  //             {
  //               key:  "couriers",
  //               label: "Transport Providers",
  //             },
  //             {
  //               key:  "product",
  //               label: "Products",
  //             },
  //             {
  //               key: "sensor",
  //               label: "Sensors",
  //             },
  //             {
  //               key:  "location",
  //               label: "Locations",
  //             },
  //           ],
  //         },
  //       ]
  //     : []),
  // ];


  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    navigate(`${e?.key}`);
  };

  const handleBackClick = () => {
    navigate(backUrl);
  };

  const getSelectedKeys = () => {
    const currentPath = location?.pathname.split("/")[2];
    const activeItem = items
      .flatMap((group) => group.children)
      .find((item) => item?.key.split("/")[2] === currentPath);
    return activeItem ? [activeItem?.key] : [];
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991); // Mobile size threshold (you can adjust)
    };

    handleResize(); // Check size on mount
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Flatten the items for mobile view
  const mobileMenuItems = items
    .flatMap((group) => group?.children)
    .map((child) => ({
      ...child,
      label: child?.label, // Use only the labels directly
    }));

  return (
    <>
      {/* Only render the desktop menu if not on mobile */}
      {!isMobile && (
        <div className="custom-settings-menu-container">
          {isUpdateForm ? (
            <Flex
              align="center"
              onClick={handleBackClick}
              style={{ cursor: "pointer", minHeight: "38px" }}
            >
              <img src={BackArrow} alt="" />
            </Flex>
          ) : (
            <Menu
              style={{
                width: 186,
              }}
              mode="inline"
              items={items}
              onClick={handleClick}
              selectedKeys={getSelectedKeys()}
              className="custom-settings-menu"
            />
          )}
        </div>
      )}

      {/* Only render the mobile menu if on mobile */}
      {isMobile && (
        <>
          {isUpdateForm ? (
            <Flex
              align="center"
              onClick={handleBackClick}
              style={{ cursor: "pointer", minHeight: "38px" }}
            >
              <img src={BackArrow} alt="" />
            </Flex>
          ) : (
            <Menu
              mode="inline"
              items={mobileMenuItems}
              onClick={handleClick}
              selectedKeys={getSelectedKeys()}
              className="custom-settings-menu-mobile flex"
            />
          )}
        </>
      )}
    </>
  );
}

export default SettingsSidebar;
